module.exports = __webpack_public_path__ + "media/images/icon_time-ce76cad2e4c43db6d751aad134dfe09b.svg";